import React from "react";

const CloseIconNew = ({ fill="#6D7885", ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...rest}
    >
      <mask
        id="mask0_2922_208"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24"
      >
        <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2922_208)">
        <path
          d="M12.5 13.0538L7.42689 18.1269C7.28844 18.2654 7.1144 18.3362 6.90479 18.3394C6.69519 18.3426 6.51795 18.2718 6.37309 18.1269C6.2282 17.982 6.15576 17.8064 6.15576 17.6C6.15576 17.3936 6.2282 17.218 6.37309 17.0731L11.4462 12L6.37309 6.92689C6.23462 6.78844 6.16379 6.6144 6.16059 6.40479C6.15737 6.19519 6.2282 6.01795 6.37309 5.87309C6.51795 5.7282 6.69359 5.65576 6.89999 5.65576C7.10639 5.65576 7.28202 5.7282 7.42689 5.87309L12.5 10.9462L17.5731 5.87309C17.7115 5.73462 17.8856 5.66379 18.0952 5.66059C18.3048 5.65737 18.482 5.7282 18.6269 5.87309C18.7718 6.01795 18.8442 6.19359 18.8442 6.39999C18.8442 6.60639 18.7718 6.78202 18.6269 6.92689L13.5538 12L18.6269 17.0731C18.7654 17.2115 18.8362 17.3856 18.8394 17.5952C18.8426 17.8048 18.7718 17.982 18.6269 18.1269C18.482 18.2718 18.3064 18.3442 18.1 18.3442C17.8936 18.3442 17.718 18.2718 17.5731 18.1269L12.5 13.0538Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default CloseIconNew;
